
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10.5","transform":"rotate(-180 12 12)","fill":"currentColor","stroke":"#fff","stroke-width":"3"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"4","transform":"rotate(-180 12 12)","fill":"#fff"}})])
          )
        }
      }
    